/**
 * Forslagene til assistenten, per rolle (`assistant.suggested.{role}.{1..4}`).
 * Delt av SuggestedPrompts (tom tråd) og FollowUpPrompts (chipene over
 * inntastingsfeltet mens samtalen pågår, #158).
 */
export type PromptRole = 'parent' | 'teen' | 'child';

const PROMPT_IDS = ['1', '2', '3', '4'] as const;

export function suggestedPromptKeys(role: PromptRole): string[] {
  return PROMPT_IDS.map((n) => `assistant.suggested.${role}.${n}`);
}
